var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 0C20.8159 0 21.9181 0.456546 22.7308 1.2692C23.5435 2.08186 24 3.18406 24 4.33333V19.6667C24 20.8159 23.5435 21.9181 22.7308 22.7308C21.9181 23.5435 20.8159 24 19.6667 24H4.33333C3.18406 24 2.08186 23.5435 1.2692 22.7308C0.456546 21.9181 0 20.8159 0 19.6667V4.33333C0 3.18406 0.456546 2.08186 1.2692 1.2692C2.08186 0.456546 3.18406 0 4.33333 0H19.6667ZM19.6667 2H4.33333C3.71449 2 3.121 2.24583 2.68342 2.68342C2.24583 3.121 2 3.71449 2 4.33333V13.3333H8C8.24165 13.3333 8.47512 13.4209 8.65724 13.5797C8.83936 13.7385 8.9578 13.9579 8.99067 14.1973L9 14.3333C9 15.129 9.31607 15.892 9.87868 16.4547C10.4413 17.0173 11.2044 17.3333 12 17.3333C12.7956 17.3333 13.5587 17.0173 14.1213 16.4547C14.6839 15.892 15 15.129 15 14.3333C15 14.0681 15.1054 13.8138 15.2929 13.6262C15.4804 13.4387 15.7348 13.3333 16 13.3333H22V4.33333C22 3.74753 21.7796 3.18319 21.3826 2.75239C20.9856 2.32159 20.4412 2.05587 19.8573 2.008L19.6667 2Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxFilled);
export default __webpack_public_path__ + "static/media/Inbox_filled.0eadfb94c086fc96b686d873ac74fae7.svg";
export { ForwardRef as ReactComponent };